import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Loader2, Mail, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function CheckEmailPage() {
  const location = useLocation();
  const email = location.state?.email || '';
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    if (!email) {
      toast.error('No email on file. Please sign in to resend.');
      return;
    }
    setResending(true);
    try {
      await axios.post(`${API_URL}/api/auth/resend-verification`, { email });
      toast.success("If an account needs verification, we've sent a fresh email.");
    } catch (err) {
      toast.success("If an account needs verification, we've sent a fresh email.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F1F5F9] flex flex-col">
      <header className="bg-[#0f1b3d] text-white px-6 py-5">
        <Logo size="sm" variant="light" linkTo="/" />
      </header>
      <main className="flex-1 flex items-center justify-center p-6">
        <Card className="w-full max-w-md shadow-lg border-0" data-testid="check-email-card">
          <CardHeader className="text-center space-y-1 pb-6">
            <div className="mx-auto h-16 w-16 bg-[#0f1b3d]/10 rounded-full flex items-center justify-center mb-3">
              <Mail className="h-8 w-8 text-[#0f1b3d]" />
            </div>
            <CardTitle className="text-2xl font-bold text-slate-900 font-['Public_Sans']">
              Check your email
            </CardTitle>
            <CardDescription className="text-slate-500">
              We've sent a verification link{email ? <> to <strong className="text-slate-700">{email}</strong></> : null}.
              Click the link to activate your account. The link expires in 60 minutes.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {email && (
              <Button
                onClick={handleResend}
                variant="outline"
                className="w-full h-12 rounded-full border-2 border-[#0f1b3d] text-[#0f1b3d] font-medium"
                disabled={resending}
                data-testid="check-email-resend-btn"
              >
                {resending ? (
                  <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Sending...</>
                ) : (
                  <><RefreshCw className="mr-2 h-4 w-4" />Resend verification email</>
                )}
              </Button>
            )}
            <Link to="/login" className="block">
              <Button
                variant="ghost"
                className="w-full h-12 rounded-full text-slate-600"
                data-testid="check-email-back-to-login"
              >
                Back to sign in
              </Button>
            </Link>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
